export default "__VITE_ASSET__CNH_NRdX__"